import { handleActions } from 'redux-actions';

import {
  setTarifacion,
  setIdCotizacionActual,
  setIngresoInfCliente,
  setLoadingCotizador,
} from '../actionsMex/aCarrito';

export const CarritoMex = handleActions(
  {
    [setTarifacion]: (state, action) => {
      console.log('SETTER: ', action);

      return {
        ...state,
        setTarifacion: action.payload,
      };
    },
    [setIdCotizacionActual]: (state, action) => ({
      ...state,
      setIdCotizacionActual: action.payload,
    }),
    [setIngresoInfCliente]: (state, action) => ({
      ...state,
      setIngresoInfCliente: action.payload,
    }),
    [setLoadingCotizador]: (state, action) => ({
      ...state,
      setLoadingCotizador: action.payload,
    }),
  },
  {
    setTarifacion: undefined,
    setIdCotizacionActual: undefined,
    setIngresoInfCliente: false,
    setLoadingCotizador: false,
  },
);
